var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptodataYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.396,
    height: 19.03,
    viewBox: "0 0 26.396 19.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptodata-youtube",
    transform: "translate(0.25 -72.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3689",
    "data-name": "Group 3689",
    transform: "translate(0 72.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3688",
    "data-name": "Group 3688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17757",
    "data-name": "Path 17757",
    d: "M196.411,176.959l-5.216-2.709a1.318,1.318,0,0,0-1.925,1.169v5.435a1.318,1.318,0,0,0,1.928,1.168l5.216-2.726a1.318,1.318,0,0,0,0-2.338Zm-.475,1.423h0l-5.216,2.726a.291.291,0,0,1-.281-.009.288.288,0,0,1-.138-.245V175.42a.287.287,0,0,1,.418-.254l5.216,2.709a.286.286,0,0,1,0,.508Z",
    transform: "translate(-179.696 -168.98)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17758",
    "data-name": "Path 17758",
    d: "M24.805,74.5h0c-1.007-1.2-2.779-1.686-6.114-1.686H7.2c-3.415,0-5.217.52-6.222,1.8C0,75.86,0,77.567,0,79.929v4.3c0,1.94.164,3.923,1.352,5.279,1.1,1.251,2.955,1.834,5.852,1.834H18.691c2.891,0,4.515-.426,5.606-1.469,1.12-1.072,1.6-2.76,1.6-5.644v-4.3C25.9,77.433,25.82,75.707,24.805,74.5Zm.059,9.731c0,2.575-.383,4.04-1.28,4.9-.878.84-2.295,1.182-4.892,1.182H7.2c-5.281,0-6.172-1.876-6.172-6.081v-4.3c0-2.155,0-3.712.761-4.679.784-1,2.352-1.4,5.411-1.4H18.691c2.994,0,4.537.382,5.324,1.318h0c.789.938.848,2.494.848,4.763Z",
    transform: "translate(0 -72.816)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodataYoutube);
export default __webpack_public_path__ + "static/media/cryptodata-youtube.b7ebf6086b7b6142e56881c72a68c99d.svg";
export { ForwardRef as ReactComponent };